<div class="tabs dashboard-component-tabs is-boxed is-small is-marginless">
  <ul>
    <li class="is-active">
      <a><span i18n>Events</span></a>
    </li>
  </ul>
</div>

@if (lockout && findSperrBra()) {
  <div class="columns-wrapper">
    <div class="columns has-background-grey-lighter">
      <div class="column has-text-weight-bold" i18n>Lockout period</div>
    </div>
    <div class="columns has-background-grey-lighter">
      <div class="column has-text-weight-semibold">
        <app-labeled-field label="" value="{{lockout.dateStart}} - {{lockout.dateEnd}}"></app-labeled-field>
      </div>
    </div>
  </div>
}

@if (plotIds.length >= 1) {
  @if (events && events.length > 0) {
    <table
      class="table is-narrow is-hoverable is-fullwidth table-compact">
        <thead>
          <tr>
            <th (click)="sortBy('type')">
              <div class="cell-wrapper is-flex is-flex-direction-row is-align-items-center is-justify-content-flex-start">
                @if (sorting && sorting.column === 'type') {
                  <span class="indicator indicator-{{sorting.direction}}"></span>
                }
                <ng-container i18n>Event Type</ng-container>
              </div>
            </th>
            <th (click)="sortBy('date')">
              <div class="cell-wrapper is-flex is-flex-direction-row is-align-items-center is-justify-content-flex-end">
                @if (sorting && sorting.column === 'date') {
                  <span class="indicator indicator-{{sorting.direction}}"></span>
                }
                <ng-container i18n>Date</ng-container>
              </div>
            </th>
            <th (click)="sortBy('source')">
              <div class="cell-wrapper is-flex is-flex-direction-row is-align-items-center is-justify-content-flex-start">
                @if (sorting && sorting.column === 'source') {
                  <span class="indicator indicator-{{sorting.direction}}"></span>
                }
                <ng-container i18n>Source</ng-container>
              </div>
            </th>
            <th>
              <div class="cell-wrapper is-flex is-flex-direction-row is-align-items-center is-justify-content-flex-start">
                <ng-container i18n>Valid</ng-container>
              </div>
            </th>
            <!-- <th>
            <div class="cell-wrapper is-flex is-flex-direction-row is-align-items-center is-justify-content-flex-start">
              <ng-container i18n>ResultComment</ng-container>
            </div>
          </th> -->
        </tr>
      </thead>
      <tbody>
        @for (event of events; track event) {
          <tr
        [ngClass]="{'is-pink': findSperrBra() && checkDate(event.date),
        'grey-background': !event.valid , 'grey-text': !!activeAssessmentStatus }">
            <td class="has-text-left">
              {{event.type}}
            </td>
            <td class="has-text-right">
              {{event.date | date:'short'}}
            </td>
            <td class="has-text-left">
              {{event.source}}
            </td>
            <td class="has-text-centered">
              <input type="checkbox" [(ngModel)]="event.valid" [disabled]="!!activeAssessmentStatus" (ngModelChange)="onValidChange(event)">
            </td>
            <!-- <td class="has-text-left">
            {{event.resultComment}}
          </td> -->
        </tr>
      }
    </tbody>
  </table>
  } @else {
    <div class="content-placeholder" i18n>No events available.</div>
  }
} @else {
  <div class="content-placeholder" i18n>No plot selected.</div>
}

